import moment from 'moment';
import { PencilSquareIcon } from '@heroicons/react/16/solid';
import { DeleteOutlined } from '@ant-design/icons';

const HolidayTable = ({ holidays = [], onEdit, onDelete, loading }) => {
  const T_Head = ["S.No", "From Date", "To Date", "Description", "Action"];

  return (
    <div className="font-[sans-serif] overflow-x-auto">
      {loading ? (
        <table className="min-w-full bg-white dark:bg-darkgray">
          <thead className="bg-primaryPurple dark:bg-lightgrey whitespace-nowrap">
            <tr>
              {T_Head.map((item, index) => (
                <th className="p-4 text-left text-sm md:text-lg font-bold text-white" key={index}>
                  {item}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array(10).fill(0).map((_, rowIndex) => (
              <tr key={rowIndex} >
                {T_Head.map((_, colIndex) => (
                  <td
                    key={colIndex}
                    className="p-4 border-b border-gray-100 dark:border-gray-700 animate-pulse"
                  >
                    <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-full"></div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <table className="min-w-full bg-white dark:bg-gray-800">
          <thead className="bg-primaryPurple dark:bg-lightgrey whitespace-nowrap">
            <tr>
              {T_Head.map((item, index) => (
                <th
                  className="p-4 text-left text-sm md:text-lg font-bold text-white"
                  key={index}
                >
                  {item}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="whitespace-nowrap">
            {
              holidays.length === 0 ?
               <tr className="bg-gray-50 dark:bg-gray-800">
                <td colSpan={5}>
                  <div className="min-h-[200px] sm:min-h-[300px] lg:min-h-[400px]
                    flex flex-col items-center justify-center
                    text-center gap-2">
                    <p className="animate-pulse text-sm sm:text-base font-medium text-gray-800 dark:text-white">
                       Data is currently unavailable
                    </p>
                    <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">
                      Please check back later or try refreshing.
                    </p>
                  </div>
                </td>
              </tr>
              :
            holidays?.map((item, index) => (
              <tr className="even:bg-blue-50 dark:even:bg-gray-700 dark:bg-gray-800 text-center text-gray-900 dark:text-white" key={index}>
                <td className="p-4 text-sm ">{index + 1}</td>
                <td className="p-4 text-sm ">
                  {moment(item?.FROMDATE).format("DD-MMM-YYYY")}
                </td>
                <td className="p-4 text-sm ">
                  {moment(item?.TODATE).format("DD-MMM-YYYY")}
                </td>
                <td className="p-4 text-sm ">{item?.DESCRIPTION}</td>
                <td className="p-4 text-sm ">
                  <div className="flex items-center gap-2">
                    <div
                      className="cursor-pointer w-fit bg-blue-100 p-1 rounded"
                      onClick={() => {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                        onEdit({
                          fromDate: item.FROMDATE,
                          toDate: item.TODATE,
                          description: item.DESCRIPTION,
                          ID: item.ID,
                        });
                      }}
                    >
                      <PencilSquareIcon className="h-6 w-6 text-blue-500" />
                    </div>
                    <div
                      className="cursor-pointer w-fit bg-red-100 p-1 rounded"
                      onClick={() => onDelete(item.ID)}
                    >
                      <DeleteOutlined className="text-red-500 text-lg" />
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default HolidayTable;